import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { FaFileSignature } from 'react-icons/fa';

const getSigningStatusClassname = document => {
  switch (document.signingStatus) {
    case 1:
      return '';
    case 2:
      return 'text-orange';
    case 3:
    case 4:
    case 11:
    case 12:
      return 'text-danger';
    case 10:
      return 'text-blue';
    case 20:
    case 21:
      return 'text-success';
    default:
      return '';
  }
};

const getSigningStatusTooltip = (document, intl) => {
  if (document.signingFailedReason) return document.signingFailedReason;

  return intl.formatMessage(listItemMsg('signingStatus', document.signingStatus));
};

const DocumentSigningStatusIcon = ({ document, intl }) => (
  <div className="btn-group margin10R">
    <FaFileSignature
      title={getSigningStatusTooltip(document, intl)}
      size="1.5em"
      className={getSigningStatusClassname(document)}
    />
  </div>
);

DocumentSigningStatusIcon.propTypes = {
  intl: intlShape.isRequired,
  document: PropTypes.shape({}).isRequired,
};

export default injectIntl(DocumentSigningStatusIcon);
